$(() => {
   if($('.template-product').length){
     let CurrentVariantInput = $('#current-variant');

     CurrentVariantInput.attrchange({
       trackValues: true,
       callback: function(e){
           e.newValue
         
          $('.grid-item-status').hide(); 
          $('.grid-item-status[data-variant="'+e.newValue+'"]').show();
       }
     });
     
   }
});